import { AlarmChannel } from "apis/alarm-settings";
import React from "react";
import { MainPolicySettingBlock, PolicyCustomizeSection, SubPolicySettingBlock } from "uis/Section";
import UI from "@mile-meeting/mile-ui";
import { useToast } from "hook/useToast";

type ReservationNotificationSettingProps = {
  isActivated?: boolean;
  channel?: AlarmChannel;
  onChange?: (value: boolean) => void;
  onChangeChannel?: (channel: AlarmChannel) => void;
  isSlackConnected?: boolean;
};

const ReservationNotificationSetting: React.FC<ReservationNotificationSettingProps> = ({
  isActivated = false,
  channel = AlarmChannel.EMAIL,
  onChange,
  onChangeChannel,
  isSlackConnected = false,
}) => {
  const { showToast } = useToast();
  return (
    <PolicyCustomizeSection title="예약 알림">
      <MainPolicySettingBlock
        title="예약 알림 활성화"
        description="활성화 시 회의실 예약 / 초대 / 변경 / 취소에 대한 알림을 전송합니다."
        rightChildren={<UI.Selection.Toggle.Default onChange={onChange} state={isActivated} size="large" />}
        haveChildren={isActivated}
      />
      {isActivated && (
        <SubPolicySettingBlock
          title="예약 알림 채널"
          description="설정한 채널로 예약 알림을 전송합니다."
          rightChildren={
            <div style={{ display: "flex", gap: "20px" }}>
              <div style={{ display: "flex", gap: 4 }} onClick={() => onChangeChannel?.(AlarmChannel.EMAIL)}>
                <UI.Radio selected={channel === AlarmChannel.EMAIL} />
                <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                  E-mail
                </UI.Typography>
              </div>
              <div
                style={{ display: "flex", gap: 4 }}
                onClick={() => {
                  if (isSlackConnected) onChangeChannel?.(AlarmChannel.SLACK);
                  else showToast("Slack 미연동 상태입니다. 서비스 연동 관리에서 Slack을 연동해 주세요.", "warning");
                }}
              >
                <UI.Radio selected={channel === AlarmChannel.SLACK} disabled={!isSlackConnected} />
                <UI.Typography
                  type="body01 normal"
                  fontStyle="regular"
                  color={isSlackConnected ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
                >
                  Slack
                </UI.Typography>
              </div>
            </div>
          }
        />
      )}
    </PolicyCustomizeSection>
  );
};

export default React.memo(ReservationNotificationSetting);
